import { Dialog } from 'vant';
export default {

    // Application Constructor
    initialize: function () {
        this.bindEvents();
    },

    // Bind any events that are required.
    // Usually you should subscribe on 'deviceready' event to know, when you can start calling cordova modules
    bindEvents: function () {
        document.addEventListener('deviceready', this.onDeviceReady, false);
        document.addEventListener('chcp_updateLoadFailed', this.onUpdateLoadError, false);
    },

    // deviceready Event Handler
    onDeviceReady: function () {

        let chcp = window.chcp;
        // 检测更新
        chcp.fetchUpdate((error, data) => {

            // 表示没有更新版本，或者其他错误，详情的信息参考上面的chcp error链接
            if (error) {
                console.log(
                    "--更新版本异常，或其他错误--",
                    error.code,
                    error.description
                );
                // if (error.code === -2) {
                //     var dialogMessage = "有新的版本是否下载";
                //调用升级提示框 点击确认会跳转对应商店升级
                // chcp.requestApplicationUpdate(dialogMessage, null, null);
                // }
                return;
            }

            // 这次更新的版本信息
            console.log('--fetchUpdate--', data, data.config);
            // 检测是否是否可以进行安装了，双重判断吧，有时候会出现有更新版本但是暂时无法安装的情况（也可以去掉这一层）
            chcp.isUpdateAvailableForInstallation((error, data) => {

                if (error) {
                    console.log('No update was loaded => nothing to install');
                } else {
                    Dialog.alert({
                        message: "已更新到最新版本，确认重启",
                    }).then(() => {
                        // 更新中
                        chcp.installUpdate((error) => {
                            if (error) {
                                // 更新失败
                                console.log('Failed to install the update with error code: ' + error.code);
                                console.log(error.description);
                            } else {
                                // 更新成功，延迟1秒后重启应用
                                console.log('Update installed! Restarting app...');
                                setTimeout(() => {
                                    // 使用cordova-plugin-exitapp插件重启应用
                                    if (window.cordova && window.cordova.plugins && window.cordova.plugins.exitapp) {
                                        window.cordova.plugins.exitapp.exitApp();
                                    } else {
                                        // 备用方案：重新加载页面
                                        window.location.reload();
                                    }
                                }, 1000);
                            }
                        });
                    });
                    // // 询问用户是否更新
                    // if (window.confirm('检测到新版本，是否更新')) {
                    //     // 更新中
                    //     chcp.installUpdate((error) => {
                    //         if (error) {
                    //             // 更新失败
                    //             console.log('Failed to install the update with error code: ' + error.code);
                    //             console.log(error.description);
                    //         } else {
                    //             // 更新成功
                    //             console.log('Update installed!');
                    //         }
                    //     });
                    // } else {
                    //     window.alert('您已拒绝更新');
                    // }

                    // 对比版本号
                    console.log('Current content version: ' + data.currentVersion);
                    console.log('Ready to be installed:' + data.readyToInstallVersion);
                }

            });
        });

    },

    onUpdateLoadError: function (eventData) {
        var error = eventData.detail.error;
        if (error && error.code == chcp.error.APPLICATION_BUILD_VERSION_TOO_LOW) {
            console.log('有新的版本');
            var dialogMessage = '有新的版本是否下载';
            chcp.requestApplicationUpdate(dialogMessage, this.userWentToStoreCallback, this.userDeclinedRedirectCallback);
        }
    },

    userWentToStoreCallback: function () {
        // user went to the store from the dialog
    },

    userDeclinedRedirectCallback: function () {
        // User didn't want to leave the app.
        // Maybe he will update later.
    }
}



// WEBPACK FOOTER //
// ./src/box/hot_update.js